import React from "react";
import { useCart } from "./CartContext";
import "../../styles.css";

const QuantityButton = ({ item }) => {
  const { updateCartItemQuantity } = useCart();

  const handleIncrease = () => {
    updateCartItemQuantity(
      item.id,
      item.fabric,
      item.rangeModel,
      item.optionalExtras,
      item.quantity + 1
    );
  };

  const handleDecrease = () => {
    updateCartItemQuantity(
      item.id,
      item.fabric,
      item.rangeModel,
      item.optionalExtras,
      item.quantity - 1
    );
  };

  return (
    <div className="quantity-buttons">
      <button
        className="quantity-decrease"
        onClick={handleDecrease}
        disabled={item.quantity <= 1}
      >
        -
      </button>
      <button className="quantity-increase" onClick={handleIncrease}>
        +
      </button>
    </div>
  );
};

export default QuantityButton;
